import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class RoleSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { items: [] };
        this.getRoles = this.getRoles.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getRoles();
    }

    componentWillUnmount() {

    }

    getRoles() {
        this.http.get('/api/Users/GetRoles', null).then(data=>{
            this.setState({ items: data });
            if(data.length > 0 && this.props.value === 0){
                this.props.onChange(data[0].key);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.items.map((item) =>
            <option key={item.key} value={item.key}>{item.value}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                <option value="-1">--SELECT--</option>
                {options}
            </select>
        );
    }
}
export default RoleSelect